import { Link } from 'react-router-dom';
import { tickerItems } from '@/mocks/site';
import { articles } from '@/mocks/articles';
import type { Article } from '@/types/content';

const allArticles = articles as Article[];

const BreakingTicker = () => {
  const loop = [...tickerItems, ...tickerItems];

  return (
    <div className="bg-accent-600 text-background-50">
      <div className="flex items-center gap-0 px-4 md:px-6 h-11">
        <span className="flex items-center gap-1.5 shrink-0 pr-4 mr-4 border-r border-background-50/30 text-sm font-medium">
          <span className="w-2 h-2 rounded-full bg-background-50 heat-dot" />
          实时快讯
        </span>
        <div className="overflow-hidden flex-1">
          <div className="marquee-track flex w-max items-center">
            {loop.map((text, index) => {
              const target = allArticles[index % allArticles.length];
              return (
                <Link
                  key={`${text}-${index}`}
                  to={`/article/${target.id}`}
                  className="flex items-center gap-2 pr-10 text-sm whitespace-nowrap text-background-50/95 transition-colors hover:text-background-50 hover:underline underline-offset-4"
                >
                  <i className="ri-flashlight-fill text-secondary-300" />
                  {text}
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakingTicker;